import { Controller } from '@hotwired/stimulus';

export default class GtmController extends Controller {
  pushEvent(event) {
    window.GTM.pushEvent(event.params.event);
  }
}
